module.exports = __webpack_public_path__ + "static/img/cont61 (2).65d27ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont61 (2).jpg
// module id = 8V1G
// module chunks = 0